import {defaultDateFormat} from '../../../common/DatePicker';

export default {
    ss_no: {
        label: 'SS No',
        placeholder: 'Add SS No',
        system: {
            name: 'ss_no',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'ss_no',
        rules: {
            title: 'SS No field',
            required: true,
            range:{
                min: 9,
                max: 9,
                message: "{title} must be of {min} didgets and in a format xxx-xx-xxxx"
            }
        },
        mask: '999-99-9999',
        maskChar: '_'
    },
    firstname: {
        label: 'First Name',
        placeholder: 'Add First Name',
        system: {
            name: 'firstname',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'firstname',
        rules: {
            title: 'First Name field',
            required: true
        }
    },
    lastname: {
        label: 'Last Name',
        placeholder: 'Add Last Name',
        system: {
            name: 'lastname',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'lastname',
        rules: {
            title: 'Last Name field',
            required: true
        }
    },
    department: {
        label: 'Department',
        placeholder: 'Add Department',
        system: {
            name: 'department',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'department',
        rules: {
            title: 'Department field',
        }
    },
    job_title: {
        label: 'Job Title',
        placeholder: 'Add Job Title',
        system: {
            name: 'job_title',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'job_title',
        rules: {
            title: 'Job Title field',
        }
    },
    status: {
        label: 'Status',
        placeholder: 'Add Status',
        system: {
            name: 'status',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'status',
        rules: {
            title: 'Status field',
            required: true,
        }
    },
    cell_phone: {
        label: 'Cell Phone',
        placeholder: 'Add Cell Phone',
        system: {
            name: 'cell_phone',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'cell_phone',
        rules: {
            title: 'Cell Phone field',
        }
    },
    work_phone: {
        label: 'Work Phone',
        placeholder: 'Add Work Phone',
        system: {
            name: 'work_phone',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'work_phone',
        rules: {
            title: 'Work Phone field',
        }
    },
    birthdate: {
        label: 'Birthdate',
        placeholder: 'Add Birthdate',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            name: 'birthdate',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'birthdate',
        rules: {
            title: 'Birthdate field'
        }
    },
    original_hire_date: {
        label: 'Hire Date (original)',
        placeholder: 'Add Hire Date (original)',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            name: 'original_hire_date',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'original_hire_date',
        rules: {
            title: 'Hire Date (original) field'
        }
    },
    tenure: {
        label: 'Tenure',
        placeholder: 'Add Tenure',
        system: {
            name: 'tenure',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'tenure',
        rules: {
            title: 'Tenure field',
            ignoreNull: true,
            numeric: true
        }
    },
    address1: {
        label: 'Address',
        placeholder: 'Add Address',
        system: {
            name: 'address1',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'address1',
        rules: {
            title: 'Address field',
        }
    },
    city: {
        label: 'City',
        placeholder: 'Add City',
        system: {
            name: 'city',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'city',
        rules: {
            title: 'City field',
        }
    },
    state_id: {
        label: 'State',
        placeholder: 'Add State',
        system: {
            name: 'state_id',
        },
        value: '44', //Texas
        errors: [],
        type: 'text',
        name: 'state_id',
        rules: {
            title: 'State field'
        }
    },
    zip: {
        label: 'Zip',
        placeholder: 'Add Zip',
        system: {
            name: 'zip',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'zip',
        rules: {
            title: 'Zip field',
        }
    },
    country_id: {
        label: 'Country',
        placeholder: 'Add Country',
        system: {
            name: 'country_id',
        },
        value: '226', //USA
        errors: [],
        type: 'text',
        name: 'country_id',
        rules: {
            title: 'Country field'
        }
    },
    province: {
        label: 'Province',
        placeholder: 'Add Province',
        system: {
            name: 'province',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'province',
        rules: {
            title: 'Province field'
        }
    },
    start_rate: {
        prefix: '$',
        label: 'Start Rate',
        placeholder: 'Add Start Rate',
        system: {
            name: 'start_rate',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'start_rate',
        rules: {
            title: 'Total Start Rate',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    earnings_rate: {
        prefix: '$',
        label: 'Earnings Rate',
        placeholder: 'Add Earnings Rate',
        system: {
            name: 'earnings_rate',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'earnings_rate',
        rules: {
            title: 'Earnings Rate',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    last_earnings_rate: {
        prefix: '$',
        label: 'Last Earnings Rate',
        placeholder: 'Add Last Earnings Rate',
        system: {
            name: 'last_earnings_rate',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'last_earnings_rate',
        rules: {
            title: 'Last Earnings Rate',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    start_salary: {
        prefix: '$',
        label: 'Start Salary',
        placeholder: 'Start Salary',
        system: {
            name: 'start_salary',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'start_salary',
        rules: {
            title: 'Start Salary field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    previous_salary: {
        prefix: '$',
        label: 'Previous Salary',
        placeholder: 'Previous Salary',
        system: {
            name: 'previous_salary',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'previous_salary',
        rules: {
            title: 'Previous Salary field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    current_salary: {
        prefix: '$',
        label: 'Current Salary',
        placeholder: 'Current Salary',
        system: {
            name: 'current_salary',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'current_salary',
        rules: {
            title: 'Current Salary field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        }
    },
    vacation_limit: {
        label: 'Vacation Limit',
        placeholder: 'Add Vacation Limit',
        system: {
            name: 'vacation_limit',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'vacation_limit',
        rules: {
            title: 'Vacation Limit field',
            ignoreNull: true,
            numeric: true
        }
    },
    vacation_used: {
        label: 'Vacation Used',
        placeholder: 'Add Vacation Used',
        system: {
            name: 'vacation_used',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'vacation_used',
        rules: {
            title: 'Vacation Used field',
            ignoreNull: true,
            numeric: true
        }
    },
    vacation_available: {
        label: 'Vacation Available',
        placeholder: 'Add Vacation Available',
        system: {
            name: 'vacation_available',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'vacation_available',
        rules: {
            title: 'Vacation Available field',
            ignoreNull: true,
            numeric: true
        }
    },
    last_worked_date: {
        label: 'Last Worked Date',
        placeholder: 'Add Last Worked Date',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            name: 'last_worked_date',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'last_worked_date',
        rules: {
            title: 'Last Worked Date field'
        }
    },
    last_check_date: {
        label: 'Last Check Date',
        placeholder: 'Add Last Check Date',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            name: 'last_check_date',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'last_check_date',
        rules: {
            title: 'Last Check Date field'
        }
    },
    termination_reason: {
        label: 'Termination Reason',
        placeholder: 'Add Termination Reason',
        system: {
            name: 'termination_reason',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'termination_reason',
        rules: {
            title: 'Termination Reason field',
        }
    },
    rehire_eligibility: {
        label: 'Rehire Eligibility',
        placeholder: '',
        system: {
            name: 'rehire_eligibility',
        },
        value: false,
        errors: [],
        type: 'checkbox',
        name: 'rehire_eligibility',
        rules: {}
    },
    rehire_eligibility_date: {
        label: 'Rehire Eligibility Date',
        placeholder: 'Add Rehire Eligibility Date',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            name: 'rehire_eligibility_date',
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'rehire_eligibility_date',
        rules: {
            title: 'Rehire Eligibility Date field'
        }
    },
    vacations: [],
    emergency_contacts: [],
    bonuses: [],
    insurance_plans: [],
    past_raises: [],
    disciplinary_actions: [],
    working_terms: []
};



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/fields.js